// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"359":"b61d8531","443":"04a0b068","528":"6369124e","644":"2e4f091c","691":"dc61b0ca","996":"52e24abd"}[chunkId] + ".js";
};